import { useState } from 'react';
import { withAppHOC } from '../../hoc';
import {
  StyledContentContainer,
  StyledMainAreaContainer,
} from '../../components/styled';
import PageHeader from '../../components/PageHeader/PageHeader';
import {
  Form,
  Fieldset,
  Label,
  MessageBox,
  Button,
  TextInput,
  OTPInput,
  Dropdown,
} from '../../components/FormElements';
import API from '../../api';
import { RESPONSE_STATUSES } from '../../constants';
import { isEmpty } from 'lodash';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import styled from 'styled-components';
import { getAuthData } from '../../utils';
import { Heading1 } from '../../components/Headings';

const StyledContent = styled.p`
  color: green;
  display: block;
  flex: 2;
  text-transform: uppercase;
`;

const StyledKYCPendingMessageContainer = styled.section`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 15px;
  margin: 50px 0px;
  svg {
    font-size: 60px;
    color: #0095ff;
  }
  h1 {
    margin: 0px;
    padding: 0px;
  }
  p {
    font-size: 14px;
    color: #222222;
    margin: 0px;
    padding: 0px;
  }
`;

const KYCPending = () => {
  const {
    userProfile: {
      gstWalletStatus,
      gstInvoiceP2AStatus,
      gstInvoiceP2PStatus,
      kycStatus,
      kycRemark,
      firmType,
    },
  } = getAuthData();
  const gstTypeOptions = [{ name: '-- SELECT GST TYPE --', value: '' }];
  if (gstInvoiceP2PStatus && gstInvoiceP2PStatus === 'Active') {
    gstTypeOptions.push({
      name: 'P2P',
      value: 'P2P',
    });
  }
  if (gstInvoiceP2AStatus && gstInvoiceP2AStatus === 'Active') {
    gstTypeOptions.push({
      name: 'P2A',
      value: 'P2A',
    });
  }
  const [state, setState] = useState({
    isLoading: false,
    responseStatus: '',
    responseMessage: '',
    aadhaarNumber: '',
    aadhaarName: '',
    aadhaarRequestToken: '',
    aadhaarOTP: '',
    aadhaarStage: 'REQUEST',
    aadhaarFile: '',
    panNumber: '',
    panName: '',
    panFile: '',
    isGSTSeller: firmType == '7' ? 'No' : 'Yes',
    gstNumber: '',
    gstName: '',
    gstFile: '',
    gstType: 'P2P',
  });

  const getAadhaarOTP = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: '',
      responseMessage: '',
    }));
    try {
      const response = await API.post('/authentication/fetch-aadhaar-otp', {
        aadhaarNumber: state.aadhaarNumber,
      });
      const { status, message, data } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          aadhaarRequestToken: data,
          aadhaarStage: 'OTP',
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: '',
            responseMessage: '',
          }));
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const fetchAadhaar = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: '',
      responseMessage: '',
    }));
    try {
      const response = await API.post('/authentication/fetch-aadhaar', {
        aadhaarNumber: state.aadhaarNumber,
        aadhaarOtp: state.aadhaarOTP,
        aadhaarRequestToken: state.aadhaarRequestToken,
      });
      const { status, message, data, actualData } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          aadhaarName: data,
          aadhaarFile: actualData,
          aadhaarStage: 'SUCCESS',
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: '',
            responseMessage: '',
          }));
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const fetchPan = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: '',
      responseMessage: '',
    }));
    try {
      const response = await API.post('/authentication/fetch-pan', {
        panNumber: state.panNumber,
      });
      const { status, message, data, actualData } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          panName: data,
          panFile: actualData,
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: '',
            responseMessage: '',
          }));
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const fetchGst = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: '',
      responseMessage: '',
    }));
    try {
      const response = await API.post('/authentication/fetch-gst', {
        gstNumber: state.gstNumber,
      });
      const { status, message, data, actualData } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
          gstName: data,
          gstFile: actualData,
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: '',
            responseMessage: '',
          }));
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      responseStatus: '',
      responseMessage: '',
    }));
    try {
      const response = await API.post('/authentication/kyc', {
        panName: state.panName,
        panNumber: state.panNumber,
        panFile: JSON.stringify(state.panFile),
        aadhaarName: state.aadhaarName,
        aadhaarNumber: state.aadhaarNumber,
        aadhaarFile: JSON.stringify(state.aadhaarFile),
        isGSTSeller: state.isGSTSeller,
        gstName: state.isGSTSeller === 'Yes' ? state.gstName : '',
        gstNumber: state.isGSTSeller === 'Yes' ? state.gstNumber : '',
        gstFile:
          state.isGSTSeller === 'Yes' ? JSON.stringify(state.gstFile) : '',
        gstType: state.gstType,
      });
      const { status, message } = response.data;
      if (status === RESPONSE_STATUSES.SUCCESS) {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.SUCCESS,
          responseMessage: message,
        }));
        setTimeout(() => {
          setState((prevState) => ({
            ...prevState,
            responseStatus: '',
            responseMessage: '',
          }));
          window.location.reload();
        }, 3000);
      } else {
        setState((prevState) => ({
          ...prevState,
          responseStatus: RESPONSE_STATUSES.FAILED,
          responseMessage: message,
        }));
      }
    } catch (error) {
      setState((prevState) => ({
        ...prevState,
        responseStatus: RESPONSE_STATUSES.FAILED,
        responseMessage: error.message,
      }));
    } finally {
      setState((prevState) => ({ ...prevState, isLoading: false }));
    }
  };

  return kycStatus === 'Submitted' ? (
    <>
      <StyledKYCPendingMessageContainer>
        <FontAwesomeIcon icon={faExclamationCircle} />
        <Heading1>Pending KYC Verification</Heading1>
        <p>Your KYC information is submitted for verification.</p>
      </StyledKYCPendingMessageContainer>
    </>
  ) : (
    <>
      <PageHeader title="KYC Pending" />
      <StyledContentContainer>
        <StyledMainAreaContainer>
          <Form
            action="#"
            method="POST"
            onSubmit={onSubmit}
            style={{ maxWidth: '500px' }}
          >
            {!isEmpty(kycRemark) && kycStatus === 'Rejected' && (
              <Fieldset>
                <MessageBox
                  status="Rejected"
                  message={`Rejected Reason : ${kycRemark}`}
                />
              </Fieldset>
            )}
            <Fieldset>
              <Label required>PAN Number</Label>
              <TextInput
                value={state.panNumber}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    panName: '',
                    panFile: '',
                    panNumber: value,
                  }))
                }
                placeholder="PAN Number"
                disabled={state.isLoading}
              />
            </Fieldset>
            {state.panName && (
              <Fieldset>
                <Label>Name on PAN</Label>
                <StyledContent>{state.panName}</StyledContent>
              </Fieldset>
            )}
            <Fieldset>
              <Button
                onClick={fetchPan}
                disabled={state.panName || state.isLoading}
              >
                Fetch Details
              </Button>
            </Fieldset>
            <Fieldset>
              <Label required>Aadhaar Number</Label>
              <TextInput
                value={state.aadhaarNumber}
                onChange={(value) =>
                  setState((prevState) => ({
                    ...prevState,
                    aadhaarNumber: value,
                    aadhaarName: '',
                    aadhaarFile: '',
                    aadhaarRequestToken: '',
                    aadhaarOTP: '',
                    aadhaarStage: 'REQUEST',
                  }))
                }
                placeholder="Aadhaar Number"
                disabled={state.isLoading || state.aadhaarStage === 'OTP'}
              />
            </Fieldset>
            {state.aadhaarName && (
              <Fieldset>
                <Label>Name on Aadhaar</Label>
                <StyledContent>{state.aadhaarName}</StyledContent>
              </Fieldset>
            )}
            {state.aadhaarStage !== 'OTP' && (
              <Fieldset>
                <Button
                  onClick={getAadhaarOTP}
                  disabled={state.aadhaarName || state.isLoading}
                >
                  Send OTP
                </Button>
              </Fieldset>
            )}
            {state.aadhaarStage === 'OTP' && (
              <>
                <Fieldset>
                  <Label required>Aadhaar OTP</Label>
                  <OTPInput
                    value={state.aadhaarOTP}
                    onChange={(value) =>
                      setState((prevState) => ({
                        ...prevState,
                        aadhaarOTP: value,
                      }))
                    }
                    placeholder="OTP"
                    disabled={state.isLoading}
                  />
                </Fieldset>
                <Fieldset>
                  <Button onClick={fetchAadhaar} disabled={state.isLoading}>
                    Fetch Aadhaar
                  </Button>
                </Fieldset>
              </>
            )}
            {firmType != '7' && gstWalletStatus === 'Active' && (
              <>
                <Fieldset>
                  <Label required>Do you have GST ?</Label>
                  <Dropdown
                    value={state.isGSTSeller}
                    onChange={(value) =>
                      setState((prevState) => ({
                        ...prevState,
                        isGSTSeller: value,
                        gstNumber: '',
                        gstName: '',
                        gstFile: '',
                        // gstType: "",
                      }))
                    }
                    placeholder="GST Status"
                    disabled={state.isLoading}
                    options={[
                      {
                        name: '-- SELECT GST STATUS --',
                        value: '',
                      },
                      {
                        name: 'Yes',
                        value: 'Yes',
                      },
                      {
                        name: 'No',
                        value: 'No',
                      },
                    ]}
                  />
                </Fieldset>
                {state.isGSTSeller === 'Yes' && (
                  <>
                    <Fieldset>
                      <Label required>GST Number</Label>
                      <TextInput
                        value={state.gstNumber}
                        onChange={(value) =>
                          setState((prevState) => ({
                            ...prevState,
                            gstNumber: value,
                          }))
                        }
                        placeholder="GST Number"
                        disabled={state.isLoading}
                      />
                    </Fieldset>
                    {state.gstName && (
                      <Fieldset>
                        <Label>Name on GST</Label>
                        <StyledContent>{state.gstName}</StyledContent>
                      </Fieldset>
                    )}
                    <Fieldset>
                      <Button
                        onClick={fetchGst}
                        disabled={state.gstName || state.isLoading}
                      >
                        Fetch Details
                      </Button>
                    </Fieldset>
                    {/* <Fieldset>
                      <Label required>GST Type</Label>
                      <Dropdown
                        value={state.gstType}
                        onChange={(value) =>
                          setState((prevState) => ({
                            ...prevState,
                            gstType: value,
                          }))
                        }
                        placeholder="GST Type"
                        disabled={state.isLoading}
                        options={gstTypeOptions}
                      />
                    </Fieldset> */}
                  </>
                )}
              </>
            )}
            {state.responseStatus && state.responseMessage && (
              <Fieldset>
                <MessageBox
                  status={state.responseStatus}
                  message={state.responseMessage}
                />
              </Fieldset>
            )}
            <Fieldset>
              <Button disabled={state.isLoading}>Submit</Button>
            </Fieldset>
          </Form>
        </StyledMainAreaContainer>
      </StyledContentContainer>
    </>
  );
};

export default withAppHOC(KYCPending);
